




































import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// EnumsData
import { ListDisplayMode } from "@/data/constants";

// Types
import { IClientsProvider } from "@/models/providers/client";

@Component({
  components: {
    "client-list-item-switcher": () =>
      import("@/components/app/admin/clients/clientListItemSwitcher.vue")
  }
})
export default class ClientsViewSwitcher extends Vue {
  // Inject - Clients provider data

  @Inject({ from: "clientsProvider" })
  public clientsProviderData!: () => IClientsProvider;

  public get $clientsData() {
    return this.clientsProviderData();
  }

  // Props

  @Prop({ default: ListDisplayMode.GRID })
  public displayMode!: ListDisplayMode;

  // Computed

  public get isGridView() {
    return this.displayMode === ListDisplayMode.GRID;
  }

  public get skeletonSize() {
    if (!this.isGridView) return this.$store.getters["ui/isMobile"] ? 2 : 5;

    return this.$store.getters["ui/isMobile"]
      ? 2
      : this.$store.getters["isAdminContext"]
      ? this.$store.getters["ui/isFullHd"]
        ? this.$store.state.ui.nav.isCollapsed
          ? 12
          : 9
        : 6
      : 4;
  }

  public get showEmptyState() {
    return !this.$clientsData.isLoading && !this.$clientsData.total;
  }

  public get showSkeletons() {
    return (
      this.$clientsData.table.loading ||
      this.$clientsData.isLoading ||
      !this.$clientsData.total
    );
  }
}
